<template>
  <v-card flat rounded="lg">
    <v-card-text>
      <v-list dense>
        <v-list-item-group>
          <v-list-item
            v-for="(opcao, i) in opcoes"
            :key="i"
            class="mt-2"
            :to="opcao.rota"
          >
            <v-list-item-icon>
              <v-icon>{{ opcao.icone }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ opcao.descricao }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  components: {},
  data: () => ({
    opcoes: [
      {
        icone: "mdi-account-circle-outline",
        descricao: "Dados Pessoais",
        rota: "/meus-dados-pessoais",
      },
      {
        icone: "mdi-briefcase-outline",
        descricao: "Áreas de Interesse",
        rota: "/minhas-areas-interesse",
      },
      {
        icone: "mdi-account-hard-hat-outline",
        descricao: "Experiências Profissionais",
        rota: "/minhas-experiencias-profissionais",
      },
      {
        icone: "mdi-card-account-details-outline",
        descricao: "Documentação",
        rota: "/documentacao",
      },
    ],
  }),
};
</script>

<style>
</style>
